export const additionalFieldsEnum = {
  NumeroSerie: 'serialNumber',
};

export const classificationsEnum = {
  Critico: 'critical',
  Urgente: 'urgent',
  Ordinario: 'ordinary',
};

export const statusEnum = {
  AlarmeAtuadoENaoReconhecido: 'acted-not-recognized',
  AlarmeAtuadoEReconhecido: 'acted-recognized',
  AlarmeNaoAtuadoENaoReconhecido: 'not-acted-not-recognized',
  AlarmeNaoAtuadoEReconhecido: 'not-acted-recognized',
};
